/** Shared correlation value for purpose-built catalog views spanning FHIR resource types. */
export const CATALOG_VIEW_SCOPE = "catalog-definitions";
